export const setTitulares = (state, { data, total, current_page, per_page }) => {
  state.titulareslista = data;
  state.totalUsuarios = total;
  state.currentPage = current_page;
  state.perPage = per_page;
}
export const getDashboard = (state, dashboard) => {
  state.dashboard = dashboard.data;
}

export const setTitularesInfo = (state, titularesinfo) => {
  state.titularesinfo = titularesinfo.data;
}

export const setLeyendas = (state, leyendasLista) => {
  state.leyendasLista = leyendasLista.data;
};

export const setTotalUsuarios = (state, total) => {
  state.totalUsuarios = total;
};

export const setCurrentPage = (state, page) => {
  state.currentPage = page;
};

export const setPerPage = (state, perPage) => {
  state.perPage = perPage;
};
